import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { IconeDoMenu } from './IconeDoMenu';
import { destinoDa } from './menu';

/**
 * O cabeçalho de uma tela, montado a partir do item de menu que leva até ela.
 *
 * <p>Antes cada página escrevia o próprio nome e escolhia o próprio glifo, e as duas
 * coisas divergiram do menu: a barra dizia "Mapa da Ilha" com um navio numa pastilha
 * roxa, e a tela dizia "Mapa do Mundo" com um círculo dourado. Quem clica num nome
 * espera chegar nele.
 *
 * <p>O ícone vem na pastilha da cor da seção — a mesma do menu —, então a tela também
 * responde <i>em que parte do produto você está</i> antes de você ler uma palavra.
 *
 * <p>Telas fora do menu (a ficha de uma região, por exemplo) passam {@code rotulo} e
 * {@code icone} na mão: aí não há item de menu a espelhar.
 */
export function TituloDaPagina({
  rotulo,
  icone,
  cor,
  children,
  acoes,
}: {
  /** Só quando a tela não tem item no menu. */
  rotulo?: string;
  icone?: string;
  cor?: string;
  /** A linha de apoio, embaixo do título. */
  children?: ReactNode;
  /** Botões à direita, na altura do título. */
  acoes?: ReactNode;
}) {
  const { pathname } = useLocation();
  const destino = destinoDa(pathname);

  const texto = rotulo ?? destino?.rotulo ?? '';
  const desenho = icone ?? destino?.icone;
  const corDaSecao = cor ?? destino?.cor ?? 'var(--gold)';

  return (
    <div className="pg-topo">
      <div className="pg-titulo-bloco">
        <h1 className="pg-titulo">
          {desenho && (
            <span className="pg-ic" style={{ '--c': corDaSecao } as React.CSSProperties}>
              <IconeDoMenu icone={desenho} titulo={texto} />
            </span>
          )}
          {texto}
        </h1>
        {children && <div className="pg-sub">{children}</div>}
      </div>
      {acoes && <div className="pg-acoes">{acoes}</div>}
    </div>
  );
}
